import { render, staticRenderFns } from "./ContabilitaDocumentiCollegatiModal.vue?vue&type=template&id=3ecdd057&scoped=true"
import script from "./ContabilitaDocumentiCollegatiModal.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiCollegatiModal.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentiCollegatiModal.vue?vue&type=style&index=0&id=3ecdd057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdd057",
  null
  
)

export default component.exports